import * as React from 'react';
const { __, sprintf } = wp.i18n;

const PaginationNumbers = ({ page, maxNumPages, setPage, setLoading }) => {
	const getPaginationNumbers = () => {
		const numToShow = 5;
		const halfNumToShow = 2;
		const numbers = [];

		if (maxNumPages <= numToShow) {
			// If there are fewer pages than the number to show, display all pages.
			for (let i = 1; i <= maxNumPages; i++) {
				numbers.push(i);
			}
		} else if (page <= halfNumToShow) {
			// If the current page is near the beginning, show the first numToShow pages.
			for (let i = 1; i <= numToShow; i++) {
				numbers.push(i);
			}
		} else if (page >= maxNumPages - halfNumToShow) {
			// If the current page is near the end, show the last numToShow pages.
			for (let i = maxNumPages - numToShow + 1; i <= maxNumPages; i++) {
				numbers.push(i);
			}
		} else {
			// Display the current page and its neighbors on both sides.
			for (let i = page - halfNumToShow; i <= page + halfNumToShow; i++) {
				numbers.push(i);
			}
		}

		return numbers;
	};

	const setPageAndLoading = (event, newPage) => {
		event.preventDefault();

		if (newPage < 1) {
			return;
		}

		// Prevent visual pagination number flicker by setting loading before setting the page.
		setLoading(true);
		setTimeout(() => {
			setPage(newPage);
		}, 10);
	};

	const baseUrl = window.location.href.replace(/\/page\/([0-9]+)[\/]?/i, '/');
	const getPageHref = (pageNum) => {
		if (pageNum > 1) {
			return `${baseUrl}page/${pageNum}/`;
		}

		return baseUrl;
	};

	if (maxNumPages > 1) {
		const range = getPaginationNumbers();

		return (
			<nav aria-label="pagination" className="pfa-pagination">
				<a
					className={`pfa-pagination__first${page < 2 ? ' disabled' : ''}`}
					onClick={(e) => setPageAndLoading(e, 1)}
					href={baseUrl}
				>
					<span className="sr-only">{__('first page', 'wex')}</span>
				</a>
				<a
					className={`pfa-pagination__prev${page < 2 ? ' disabled' : ''}`}
					onClick={(e) => setPageAndLoading(e, page - 1)}
					href={getPageHref(page - 1)}
					rel={page - 1 > 1 ? 'canonical' : null}
				>
					<span className="sr-only">{__('previous page', 'wex')}</span>
				</a>
				<div className="pfa-pagination__nums">
					{range.map((number) => (
						<a
							key={number}
							className={
								page === number
									? 'pfa-pagination__num active'
									: 'pfa-pagination__num'
							}
							onClick={(e) => setPageAndLoading(e, number)}
							href={getPageHref(number)}
							rel={number > 1 ? 'canonical' : null}
							aria-label={sprintf(
								/* translators: %s is replaced the page number */
								__(`page %s`, 'wex'),
								number
							)}
							aria-current={page === number ? 'page' : null}
						>
							{number}
						</a>
					))}
				</div>
				<a
					className={`pfa-pagination__next${maxNumPages === page ? ' disabled' : ''}`}
					disabled={maxNumPages === page}
					aria-label={__('next page', 'wex')}
					onClick={(e) => setPageAndLoading(e, page + 1)}
					rel="canonical"
					href={getPageHref(page + 1)}
				>
					<span className="sr-only">{__('next page', 'wex')}</span>
				</a>
				<a
					className={`pfa-pagination__last${maxNumPages === page ? ' disabled' : ''}`}
					disabled={maxNumPages === page}
					aria-label={__('last page', 'wex')}
					onClick={(e) => setPageAndLoading(e, maxNumPages)}
					rel="canonical"
					href={getPageHref(maxNumPages)}
				>
					<span className="sr-only">{__('last page', 'wex')}</span>
				</a>
			</nav>
		);
	}

	return '';
};

PaginationNumbers.displayName = 'PaginationNumbers';

export default PaginationNumbers;
